import React, { useState, useEffect } from "react";
import { Auth, API } from "aws-amplify";
import "../config";
import "./Setup.css";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Datasource from '../components/Datasource';
import Featuretype from '../components/Featuretype';
import AutoRefresh from '../components/AutoRefresh';
import LoadingWrapper from '../components/LoadingWrapper';
import { useSnackbar } from 'notistack';

import { Button } from "@material-ui/core";
import { isEmpty } from "../libs/isEmpty";
import { useContainerStyles } from '../styles/commonStyles';


export default function Setup(props) {
  let  _storeDatastores = {};
  const classes = useContainerStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [datasources, setDatasources] = useState([]);
  const [featuretypes, setFeaturetypes] = useState([]);

  // Snackbar
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    //console.log('vendorMeta change i setup')
    async function fetchData() {
      setIsLoading(true)
      await refresh()
      setIsLoading(false)
    }
    fetchData()
  }, [props.vendorID])




// Featuretypes
function manageFeatureType(featureTypeArray) {
  let managed = []
  
  if (!_storeDatastores || isEmpty(_storeDatastores)) {
    refresh();
    return managed; 
  }

  _storeDatastores.forEach(store => {
    const storeFeatureType = featureTypeArray.filter((f) => {return f.ds_id === store.ds_id });
    storeFeatureType.sort ((a,b)=> (a.alias > b.alias ? 1 : -1))
    storeFeatureType.forEach(ft => {
      ft["config"] = JSON.stringify(ft["config"],null, 2)
      ft["transform"] = JSON.stringify(ft["transform"],null, 2)
      managed.push(ft)
    });
    
  }); 
  managed.sort((a,b)=> (a.alias > b.alias ? 1 : -1))
  return managed
}
async function loadFeaturetypes() {
  await getFeaturetypes(props.vendorID)
  .then(response => {
    setFeaturetypes(manageFeatureType(response.data))
  })
  .catch(response => {
    enqueueSnackbar('Kunne ikke hente featuretypes: '+ response.messsage,{variant: 'error',})
    setFeaturetypes([])
  })
}
async function getFeaturetypes(vendor_id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.post("API", "/Featuretypes/"+vendor_id, init);
}
async function createFeaturetypeHandler(values) {
  await createFeaturetype(values)
  .then(response => enqueueSnackbar('Featuretype oprettet',{variant: 'success',}))
  .then(loadFeaturetypes)
  .catch(response => enqueueSnackbar('Kunne ikke tilføje featuretype: '+ response.messsage,{variant: 'error',}))
}
async function createFeaturetype(values) {
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  return await API.post("API", "/Featuretype", values);
}
async function deleteFeaturetypeHandler(id) {
  await deleteFeaturetype(id)
  .then(response => enqueueSnackbar('Featuretype fjernet',{variant: 'success',}))
  .then(loadFeaturetypes)
  .catch(response => enqueueSnackbar('Kunne ikke fjerne featuretype: '+ response.messsage,{variant: 'error',}))
}
async function deleteFeaturetype(id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.del("API", "/Featuretype/"+id, init);
}
async function editFeaturetypeHandler(values) {
  await editFeaturetype(values)
  .then(response => enqueueSnackbar('Featuretype opdateret',{variant: 'success',}))
  .then(loadFeaturetypes)
  .catch(response => enqueueSnackbar('Kunne ikke opdatere featuretype: '+ response.messsage,{variant: 'error',}))
}
async function editFeaturetype(values) {
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  values["body"]["status_code"] = 99
  values["body"]["status_message"] = 'Featuretype er ændret siden sidste check.'
  console.log(values)
  return await API.put("API", "/Featuretype/"+values.body.ft_id, values);
}

// Datasources
function manageDatastore(dataStoreArray) {
  let managed = []
  dataStoreArray.sort((a, b) => a.alias.localeCompare(b.alias) );
  dataStoreArray.forEach(ds => {
    ds["config"] = JSON.stringify(ds["config"], null, 2)
    managed.push(ds)
  });
  return managed
}

async function loadDatasources() {
  await getDatasources(props.vendorID)
  .then(response => {
    _storeDatastores = manageDatastore(response.data)
    setDatasources(_storeDatastores)
  })
  .catch(response => {
    enqueueSnackbar('Kunne ikke hente datasources: '+ response.messsage,{variant: 'error',})
    setDatasources([])
  })
}
async function getDatasources(vendor_id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.post("API", "/Datastores/"+vendor_id, init);
}
async function createDatasourceHandler(values) {
  await createDatasource(values)
  .then(response => enqueueSnackbar('Datastore oprettet',{variant: 'success',}))
  .then(loadDatasources)
  .catch(response => enqueueSnackbar('Kunne ikke tilføje datastore: '+ response.messsage,{variant: 'error',}))
}
async function createDatasource(values) {
  values["body"]["vendor_id"] = props.vendorID
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  return await API.post("API", "/Datastore", values);
}
async function deleteDatasourceHandler(id) {
  await deleteDatasource(id)
  .then(response => enqueueSnackbar('Datastore fjernet',{variant: 'success',}))
  .then(loadDatasources)
  .catch(response => enqueueSnackbar('Kunne ikke fjerne datastore: '+ response.messsage,{variant: 'error',}))
}
async function deleteDatasource(id) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  return await API.del("API", "/Datastore/"+id, init);
}
async function editDatasourceHandler(values) {
  await editDatasource(values)
  .then(response => enqueueSnackbar('Datastore opdateret',{variant: 'success',}))
  .then(loadDatasources)
  .catch(response => enqueueSnackbar('Kunne ikke opdatere datastore: '+ response.messsage,{variant: 'error',}))
}
async function editDatasource(values) {
  values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  values["body"]["status_code"] = 99
  values["body"]["status_message"] = 'Datastore er ændret siden sidste check.'
  return await API.put("API", "/Datastore/"+values.body.ds_id, values);
}

// check
async function createCheckHandler(checktype, checkid) {
  await createCheck(checktype, checkid)
  .then(response => enqueueSnackbar('Check af '+ checktype + ' Gennemført',{variant: 'success',}))
  .catch(response => enqueueSnackbar('Kunne ikke tilføje interesseområder: '+ response.messsage,{variant: 'error',}))
  .finally(r => {
    console.log(checktype)
    switch(checktype) {
      case 'datasource':
        loadDatasources()
        break
      case 'featuretype':
        loadFeaturetypes()
        break
      default:
        console.log(checktype + ' ikke understøttet!')
    }
  })
}
async function createCheck(checktype, checkid) {
  let init = {
    headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  }
  console.log(init)
  switch(checktype) {
    case 'datasource':
      return await API.post("API", "/check/"+checktype+'/'+checkid, init);
    case 'featuretype':
      return await API.post("API", "/check/"+checktype+'/'+checkid, init);
    default:
      console.log(checktype + ' ikke understøttet!')
  }
  
  
}

function refresh() {
  if (props.vendorID === '') {
    setDatasources([])
    setFeaturetypes([])
  } else {
    loadDatasources()
    loadFeaturetypes()
  }
}

  //console.log(props)
  return (
    <div className={classes.root}>
      <AutoRefresh onRefresh={refresh} disableAuto={true} disabled={props.vendorID.length === 0} />
      <LoadingWrapper isLoading={isLoading}>
      <Grid
      container
      spacing={4}
      direction="row"
      alignItems="flex-start"
      justifyContent="flex-start"
      >
        <Grid item>
          <Datasource
          props={props}
          sources={datasources}
          vendorMeta={props.vendorMeta}
          create={createDatasourceHandler}
          delete={deleteDatasourceHandler}
          edit={editDatasourceHandler}
          check={createCheckHandler}
          />
        </Grid>
        <Grid item>
          <Featuretype
          props={props}
          featuretypes={featuretypes}
          sources={datasources}
          vendorMeta={props.vendorMeta}
          create={createFeaturetypeHandler}
          delete={deleteFeaturetypeHandler}
          edit={editFeaturetypeHandler}
          check={createCheckHandler}
          />
        </Grid>
      </Grid>
      </LoadingWrapper>
    </div>
  );
}
